import { render, staticRenderFns } from "./legend-pie2.vue?vue&type=template&id=37c4e872&scoped=true"
import script from "./legend-pie2.vue?vue&type=script&lang=js"
export * from "./legend-pie2.vue?vue&type=script&lang=js"
import style0 from "./legend-pie2.vue?vue&type=style&index=0&id=37c4e872&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37c4e872",
  null
  
)

export default component.exports